<template>
  <div class="cx-border-container">
    <div class="border-select inlineMiddle">
      <el-tooltip
        v-for="(border, index) in borderLists"
        class="border-item"
        :key="'border_' + index"
        :class="selectBorderIndex.indexOf(border.borderIndex) > -1 ? 'active' : ''"
        effect="dark"
        :open-delay="tooltipDelay"
        :content="border.toolTip"
        placement="top"
      >
        <span @click="selectBorder(border.borderIndex)" class="cx-border" :class="border.containerClass">
          <i :class="border.iconClass"></i>
        </span>
      </el-tooltip>
    </div>
    <div class="border-property inlineMiddle">
      <div class="verticallyCenter mb8 set-item-28">
        <span class="fs14 mr8">类型</span>
        <el-select class="flex1" popper-class="select-border" v-model="activeBorderStyle" placeholder="请选择">
          <el-option v-for="item in borderStyleList" :key="item.value" :label="item.label" :value="item.value">
            <div>
              <span class="selected-icon" :class="activeBorderStyle === item.value ? 'icon-portal-check-small' : ''"></span>
              <span class="border-style" :style="getBorderStyle(item)"></span>
              <span>{{ item.label }}</span>
            </div>
          </el-option>
        </el-select>
      </div>
      <div class="verticallyCenter mb8 set-item-28">
        <span class="fs14 mr8">粗细</span>
        <div class="number-input-box flex1">
          <single-input
            class="percent100"
            style="width: 100%"
            :value.sync="originActiveBorderWidth"
            inputSuffixs="px"
            :min="0"
          />
        </div>
      </div>
      <div class="set-item-28 flex3">
        <span class="fs14 mr8">颜色</span>
        <cx-color-picker
          class="color-picker-wrap"
          :isThemeColor.sync="borderIsThemeColorVal"
          :colorArr.sync="activeBorderColor"
          :activeName.sync="activeNameColorVal"
          :showSecondTab="showGradientBorder"
          :showThirdTab="showGradientBorder"
          :customClass="customClass"
        >
        </cx-color-picker>
      </div>
    </div>
  </div>
</template>

<script>
import publicData from "../mixins/publicData"

export default {
  mixins: [publicData],
  name: "cxBorder",
  props: {
    options: { type: Object },
    borderWidth: {
      type: [String, Array, Number],
      required: true
    },
    borderColor: {
      type: [String, Array, Number, Object],
      required: true
    },
    borderStyle: {
      type: [String, Array, Number],
      required: true
    },
    borderIsThemeColor: {
      type: Boolean,
      required: true
    },
    backgroundVal: {
      type: [String, Array, Number, Object],
      required: false
    },
    activeNameColor: {
      type: String,
      default: "first"
    },
    showGradientBorder: {
      type: Boolean,
    }
  },
  data() {
    return {
      this1: this,
      tooltipDelay: 1000,
      borderLists: [
        {
          toolTip: "上边框",
          borderIndex: 0,
          iconClass: "cx-border-top",
          containerClass: "item-top"
        },
        {
          toolTip: "右边框",
          borderIndex: 1,
          iconClass: "cx-border-right",
          containerClass: "item-right"
        },
        {
          toolTip: "下边框",
          borderIndex: 2,
          iconClass: "cx-border-bottom",
          containerClass: "item-bottom"
        },
        {
          toolTip: "左边框",
          borderIndex: 3,
          iconClass: "cx-border-left",
          containerClass: "item-left"
        },
        {
          toolTip: "全部",
          borderIndex: 4,
          iconClass: "cx-border-all",
          containerClass: "item-all"
        }
      ],
      borderStyleList: [
        {
          value: "solid",
          label: "实线",
          title: "",
          bigScreenSrc: require("../../assets/images/solid-1.png"),
          portalSrc: require("../../assets/images/solid-2.png")
        },
        {
          value: "dashed",
          label: "虚线",
          title: "",
          bigScreenSrc: require("../../assets/images/dashed-1.png"),
          portalSrc: require("../../assets/images/dashed-2.png")
        },
        {
          value: "dotted",
          label: "点线",
          title: "",
          bigScreenSrc: require("../../assets/images/dotted-1.png"),
          portalSrc: require("../../assets/images/dotted-2.png")
        }
      ],
      customClass: "border-color-picker-warp"
    }
  },
  mounted() {
    this.activeBorderWidth = this.originActiveBorderWidth
  },
  watch: {
    activeNameColorVal(n, o) {
      if (n !== o && n !== "first") {
        // 边框选择渐变色，没有传backgroundVal时默认取background
        const background = this.backgroundVal ? this.backgroundVal : this.options?.background
        if (!background) return
        let idx = -1
        let bgColor
        background.forEach((bg, index) => {
          if (bg.type === "color") {
            idx = index
            bgColor = bg.isThemeColor
              ? this.$store.state[this.request_prefix].page.themeColor
              : bg.color
            if (bgColor.includes("rgba") || bgColor === "rgb(255, 255, 255, 0)") {
              // 把透明度转换为1，有透明度时会透到边框渐变层
              bgColor = bgColor.replace(/,\s*\d+(\.\d+)?\s*\)/, ', 1)')
            }
          }
        })
        if (idx !== -1) {
          background[idx].color = bgColor
          if (background[idx]?.data?.stops) {
            background[idx].data.stops[0][0] = bgColor
          }
          this.$emit("update:background", background)
        }
      }
    }
  },
  computed: {
    getBorderStyle() {
      let _this = this
      return function (item) {
        let src = _this.request_prefix === "bigScreen" ? item.bigScreenSrc : item.portalSrc
        return {
          "background-image": `url(${src})`
        }
      }
    },
    borderWidthVal: {
      get() {
        let borderWidth = this.borderWidth || [0, 0, 0, 0]
        return Array.isArray(borderWidth) ? borderWidth : [borderWidth, borderWidth, borderWidth, borderWidth]
      },
      set(val) {
        this.$emit("update:borderWidth", val)
      }
    },
    borderColorVal: {
      get() {
        return this.borderColor
      },
      set(val) {
        this.$emit("update:borderColor", val)
      }
    },
    borderStyleVal: {
      get() {
        return this.borderStyle
      },
      set(val) {
        this.$emit("update:borderStyle", val)
      }
    },
    borderIsThemeColorVal: {
      get() {
        return this.borderIsThemeColor
      },
      set(val) {
        this.$emit("update:borderIsThemeColor", val)
      }
    },
    selectBorderIndex: {
      get() {
        let tempArr = []
        this.borderWidthVal.forEach((item, index) => {
          if (item !== 0) {
            tempArr.push(index)
          }
        })
        tempArr = tempArr.length === 4 || tempArr.length === 0 ? [4] : tempArr
        return tempArr
      }
    },
    originActiveBorderWidth: {
      get() {
        if (this.selectBorderIndex.length === 1 && this.selectBorderIndex[0] === 4) {
          return this.borderWidthVal[0]
        } else {
          return this.borderWidthVal[this.selectBorderIndex[0]] || 0
        }
      },
      set(val) {
        let newVal = [0, 0, 0, 0]
        if (this.selectBorderIndex.length === 1 && this.selectBorderIndex[0] === 4) {
          newVal = [val, val, val, val]
        } else {
          this.selectBorderIndex.forEach((item, index) => {
            newVal[item] = val
          })
        }
        this.$set(this, "borderWidthVal", newVal)
      }
    },
    activeBorderStyle: {
      get() {
        return this.borderStyleVal || "solid"
      },
      set(val) {
        this.selectBorderIndex.forEach(item => {
          this.borderStyleVal = val
        })
      }
    },
    activeBorderColor: {
      get() {
        return this.borderColorVal || "#fff"
      },
      set(val) {
        this.borderColorVal = val
      }
    },
    rectOptions() {
      const ids = this.$store.state.states.activeID
      let rectAttr = this.getAttrById(this.$store.state[this.request_prefix], ids)
      rectAttr = rectAttr.options ? rectAttr.options : rectAttr
      return rectAttr
    },
    activeNameColorVal: {
      get() {
        return this.activeNameColor
      },
      set(val) {
        this.$emit("update:activeNameColor", val)
      }
    },
  },
  methods: {
    selectBorder(borderIndex) {
      let index = this.selectBorderIndex.indexOf(borderIndex)
      if (borderIndex === 4 && index === -1) {
        let wid = this.borderWidthVal[this.selectBorderIndex[0]] || 1
        let tmpArr1 = [wid, wid, wid, wid]
        this.$set(this, "borderWidthVal", tmpArr1)
      }
      // 可以取消选择，但要保证至少一个选中
      if (borderIndex !== 4 && this.selectBorderIndex.length > 1 && index > -1) {
        this.$set(this.borderWidthVal, borderIndex, 0)
      }
      if (borderIndex !== 4 && index === -1) {
        let isAll = this.selectBorderIndex.length === 1 && this.selectBorderIndex[0] === 4
        let wid2 = this.borderWidthVal[isAll ? 0 : this.selectBorderIndex[0]] || 1
        let tmpArr = isAll ? [0, 0, 0, 0] : JSON.parse(JSON.stringify(this.borderWidthVal))
        this.borderWidthVal.forEach((item, index) => {
          tmpArr[index] = index === borderIndex ? wid2 : tmpArr[index]
        })
        this.$set(this, "borderWidthVal", tmpArr)
      }
    },
    getFocus(event) {
      event.currentTarget.select()
    }
  }
}
</script>

<style scoped lang="scss">
.flex3 {
  display: flex;
  align-items: flex-start;
}
::v-deep .cx_style .text_color_in_input {
  width: calc(100% - 30px);
}
.border-property {
  width: calc(100% - 108px);
}
.color-picker-wrap {
  display: inline-block;
  vertical-align: middle;
  width: calc(100% - 36px);
}
.border-select {
  position: relative;
  width: 92px;
  height: 92px;
  margin-right: 16px;
  .border-item {
    cursor: pointer;
    &.active {
      background-color: var(--themeColorSelectBg);
      i,
      i::before {
        border-color: var(--themeColor);
      }
    }
  }
  .cx-border {
    display: inline-block;
    width: 28px;
    height: 28px;
    padding: 5px;
    box-sizing: border-box;
    text-align: center;
    border-radius: 4px;
    i,
    i::before {
      border-color: var(--subTextColor);
    }
    &:not(.active):hover {
      background: rgba(31, 35, 41, 0.08);
    }
  }
  .border-item {
    position: absolute;
  }
  .item-top {
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }
  .item-bottom {
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }
  .item-right {
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  .item-left {
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  .item-all {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.selected-icon {
  position: absolute;
  top: 50%;
  left: 8px;
  font-size: 14px;
  color: var(--themeColor);
  transform: translateY(-50%);
}
.border-style {
  display: inline-block;
  width: 26px;
  height: 20px;
  margin-right: 8px;
  vertical-align: middle;
  background-position: left center;
  background-clip: content-box;
}
.cx-border-all,
.cx-border-all::before {
  box-sizing: border-box;
  position: relative;
  display: block;
  width: 18px;
  height: 18px;
}

.cx-border-all::before {
  content: "";
  position: absolute;
  border: 2px solid;
  bottom: 0;
  left: 0;
}

.cx-border-top,
.cx-border-top::before {
  box-sizing: border-box;
  position: relative;
  display: block;
  width: 18px;
  height: 18px;
  border-top: 2px solid;
}

.cx-border-top::before {
  content: "";
  position: absolute;
  height: 14px;
  border: 2px solid;
  border-top: 0;
  top: 2px;
  left: 0;
  opacity: 0.3;
}
.cx-border-bottom,
.cx-border-bottom::before {
  box-sizing: border-box;
  position: relative;
  display: block;
  width: 18px;
  height: 18px;
  border-bottom: 2px solid;
}

.cx-border-bottom::before {
  content: "";
  position: absolute;
  height: 14px;
  border: 2px solid;
  border-bottom: 0;
  bottom: 2px;
  left: 0;
  opacity: 0.3;
}

.cx-border-left,
.cx-border-left::before {
  box-sizing: border-box;
  position: relative;
  display: block;
  width: 18px;
  height: 18px;
  border-left: 2px solid;
}

.cx-border-left::before {
  content: "";
  position: absolute;
  width: 14px;
  border: 2px solid;
  border-left: 0;
  bottom: 0;
  left: 2px;
  opacity: 0.3;
}

.cx-border-right,
.cx-border-right::before {
  box-sizing: border-box;
  position: relative;
  display: block;
  width: 18px;
  height: 18px;
  border-right: 2px solid;
}

.cx-border-right::before {
  content: "";
  position: absolute;
  width: 14px;
  border: 2px solid;
  border-right: 0;
  bottom: 0;
  right: 2px;
  opacity: 0.3;
}
::v-deep .color-picker-container .color-text {
  width: calc(100% - 58px);
  left: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
::v-deep .color-picker-container:hover .color-text {
  min-width: unset;
}
.set-item-28 ::v-deep.el-input .el-input__inner {
  height: 28px;
  line-height: 28px;
  padding: 4px 0 4px 12px;
}
.set-item-28 ::v-deep.el-select .el-input__suffix-inner {
  line-height: 28px;
}
.set-item-28 ::v-deep.number-input-box .suffix_text {
  line-height: 28px;
}

.set-item-28 ::v-deep.el-input-group__append .icon-portal-arrows-up {
  margin-bottom: 0;
}
.set-item-28 ::v-deep.suffix_text {
  line-height: 28px;
}
.set-item-28 ::v-deep.el-input-group__append .icon-arrows-bg {
  height: 13px;
}
.set-item-28 ::v-deep.color-picker-container {
  height: 28px;
  padding: 4px;
}
.set-item-28 ::v-deep.color-picker-container .color-text {
  top: 4px;
}
.set-item-28 ::v-deep.color-picker-container .right-handle-icon {
  right: 4px;
  top: 2px;
}
.select-border .el-select-dropdown__item.selected {
  color: var(--subTextColor) !important;
}
</style>
